import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Benefits() {
  const benefits = ['Más claridad y confianza', 'Menos duda y autosabotaje', 'Rutina corta que sí sostienes', 'Te mueves con intención, no con ansiedad', 'Progreso real por constancia'];
  return <section className="py-8 bg-white" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2B0A3D] mb-8" data-id="element-3">
          Lo que cambia cuando dejas de improvisar
        </h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-center" data-id="element-4">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-6 rounded-2xl bg-[#F8F3EA] flex flex-col items-center gap-4" data-id="element-5">
              <Star className="w-8 h-8 text-[#D4AF37] fill-current" data-id="element-6" />
              <p className="font-semibold text-gray-800" data-id="element-7">{benefit}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}